import { useState, useEffect } from "react";
import { CountryService } from "../../services/CountryService";
import { Divider } from "primereact/divider";
import { Card } from "primereact/card";
import { AddPageHeader } from "../Common/Utils";

const showResume = (el) => {
  return (
    <div>
      <h3>{el.surname + ", " + el.firstname}</h3>
      {el["surname-first-name-translation"] && (
        <div>{el["surname-first-name-translation"]}</div>
      )}
      <br />
      <div
        style={{
          textDecoration: "underline",
          color: "black",
        }}
      >
        Main affiliation(s)
      </div>
      <ul
        style={{
          display: "inline-list-item",
          listStyle: "square",
          listStylePosition: "inside",
          paddingInlineStart: "0px",
        }}
      >
        <li>{el["affiliation-1"]}</li>
        <li>{el["affiliation-2"]}</li>
        <li>{el["affiliation-3"]}</li>
      </ul>
      {el.role}
    </div>
  );
};

const Authors = () => {
  const [authors, setAuthors] = useState([]);
  const countryService = new CountryService();

  useEffect(() => {
    countryService.getAuthors().then((data) => setAuthors(data));
  }, []);

  return (
    <div className="reduce-width">
      {AddPageHeader("Authors")}
      <Divider align="center">
        <h1>Authors</h1>
      </Divider>

      <div className="grid">
        {authors.map((el) => (
          <div key={el.surname} className="col-12 md:col-4 flex">
            <Card className="flex flex-column justify-content-between w-full">
              <div className="grid">
                <div className="flex justify-content-center flex-wrap col-12">
                  <img
                    className="flex align-items-center"
                    src={"visuals/" + el.visual}
                    alt="Author"
                    width="150em"
                  />
                </div>
                <div
                  className="flex align-items-center col-12"
                  style={{ textAlign: "left" }}
                >
                  {showResume(el)}
                </div>
              </div>
            </Card>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Authors;
